/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
import styled from 'styled-components'
import { Box, TextInput, Button } from '@usap/uicomponents'

const CouponInputContainer = styled(Box)`
  background: #fff;
  border-radius: 4px;
  padding: 0 5px;
  flex-direction: row;
  justify-content: space-between;
`

export const CouponInputContainerEmpty = styled(CouponInputContainer)`
  border: 1px solid #939393;
`

export const CouponInputContainerValid = styled(CouponInputContainer)`
  border: 1px solid #694;
`

export const CouponInputContainerError = styled(CouponInputContainer)`
  border: 1px solid #C33;
`

export const CouponTextInput = styled(TextInput)<{ isTyping: boolean, isValidCoupon: boolean, hasError: boolean }>`
  height: 48px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${({ isTyping, isValidCoupon, hasError }) => {
    if (isTyping) {
      return '#5E5E65'
    }
    if (hasError) {
      return '#C33'
    }
    if (isValidCoupon) {
      return '#669944'
    }
    return '#5E5E65'
  }};
`

export const ApplyButton = styled(Button)`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-decoration-line: underline;
  align-self: center;
  cursor: pointer;
  padding-right: 11px;

  &:disabled {
    cursor: default;
  }
`

const CouponMessage = styled.p`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding-left: 4px;
`

export const CouponValidMessage = styled(CouponMessage)`
  color: #694;
`

export const CouponMessageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 4px;
`

export const CouponErrorListItem = styled.p`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding-left: 4px;
  color: #C33;
`

export const CouponErrorListItemRedText = styled.span`
  color: #C33;
`

export const CouponErrorListItemBlackText = styled.span`
  color: #282828;
`
